"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.remove = exports.isValid = exports.hasToken = exports.getDecoded = exports.get = exports.decode = void 0;

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _moment = _interopRequireDefault(require("moment"));

var _timer = require("./timer");

var TOKEN_LS_KEY = 'ns_t';
var MODULE_NAME = 'sdk/token/utils/token';

var logger = _loglevel.default.getLogger(MODULE_NAME);
/**
 *
 * @param {string|undefined} token
 * @returns {object|null}
 */


var decode = function decode(token) {
  logger.info("".concat(MODULE_NAME, " - decode called"), token);

  if (token) {
    var decoded = (0, _jwtDecode.default)(token);
    logger.debug("".concat(MODULE_NAME, " - decode res"), decoded);
    return decoded;
  }

  logger.debug("".concat(MODULE_NAME, " - decode res"), null);
  return null;
};
/**
 *
 * @returns {string|null}
 */


exports.decode = decode;

var get = function get() {
  logger.info("".concat(MODULE_NAME, " - get called"));
  var token = localStorage.getItem(TOKEN_LS_KEY);
  logger.debug("".concat(MODULE_NAME, " - get res"), token);
  return token;
};
/**
 *
 * @returns {object|null}
 */


exports.get = get;

var getDecoded = function getDecoded() {
  logger.info("".concat(MODULE_NAME, " - getDecoded called"));
  var token = get();
  logger.debug("".concat(MODULE_NAME, " - getDecoded token"), token);

  if (token) {
    var decoded = decode(token);
    logger.debug("".concat(MODULE_NAME, " - getDecoded res"), decoded);
    return decode(token);
  }

  logger.debug("".concat(MODULE_NAME, " - getDecoded res"), null);
  return null;
};
/**
 *
 * @returns {boolean}
 */


exports.getDecoded = getDecoded;

var hasToken = function hasToken() {
  logger.info("".concat(MODULE_NAME, " - hasToken called"));
  var token = get();
  logger.debug("".concat(MODULE_NAME, " - hasToken res"), !!token);
  return !!token;
};
/**
 *
 * @param {string|undefined} token
 * @returns {boolean}
 * @private
 */


exports.hasToken = hasToken;

var validate = function validate(token) {
  logger.debug("".concat(MODULE_NAME, " - validate called"), token);

  if (!token) {
    logger.debug("".concat(MODULE_NAME, " - validate res"), false);
    return false;
  }

  var decoded = decode(token);
  logger.debug("".concat(MODULE_NAME, " - validate decoded"), decoded);

  if (!decoded) {
    return false;
  }

  if ((0, _moment.default)().unix() >= decoded.exp) {
    logger.debug("".concat(MODULE_NAME, " - validate expired"));
    return false;
  }

  if (!decoded.aud) {
    logger.debug("".concat(MODULE_NAME, " - validate missing aud"));
    return false;
  }

  if (!decoded.domain) {
    logger.debug("".concat(MODULE_NAME, " - validate missing domain"));
    return false;
  }

  if (!decoded.iat) {
    logger.debug("".concat(MODULE_NAME, " - validate missing iat"));
    return false;
  }

  if (!decoded.iss) {
    logger.debug("".concat(MODULE_NAME, " - validate missing iss"));
    return false;
  }

  if (!decoded.sub) {
    logger.debug("".concat(MODULE_NAME, " - validate missing sub"));
    return false;
  }

  if (!decoded.time_out) {
    logger.debug("".concat(MODULE_NAME, " - validate missing time_out"));
    return false;
  }

  if (!decoded.user) {
    logger.debug("".concat(MODULE_NAME, " - validate missing user"));
    return false;
  }

  logger.debug("".concat(MODULE_NAME, " - validate res"), true);
  return true;
};
/**
 *
 * @param {string|undefined} existingToken
 * @returns {boolean}
 */


var isValid = function isValid(existingToken) {
  logger.info("".concat(MODULE_NAME, " - isValid called"), existingToken);
  var token = existingToken || get();
  logger.debug("".concat(MODULE_NAME, " - isValid normalized token"), token);

  if (!token) {
    logger.debug("".concat(MODULE_NAME, " - isValid res"), false);
    return false;
  }

  var valid = validate(token);
  logger.debug("".concat(MODULE_NAME, " - isValid res"), valid);
  return valid;
};
/**
 *
 * @returns {*}
 */


exports.isValid = isValid;

var remove = function remove() {
  logger.info("".concat(MODULE_NAME, " - remove called"));
  localStorage.removeItem(TOKEN_LS_KEY);
  return true;
};
/**
 *
 * @param {string|undefined} token
 * @param {boolean} startTmr
 */


exports.remove = remove;

var set = function set(token) {
  var startTmr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  logger.info("".concat(MODULE_NAME, " - set called"), {
    token: token,
    startTmr: startTmr
  });

  if (!isValid(token)) {
    console.error("".concat(MODULE_NAME, " - set invalid token"));
    return false;
  }

  localStorage.setItem(TOKEN_LS_KEY, token);
  /*
    portal.updateSessionToken(token)
        .then(res => {
            logger.debug(
                `${MODULE_NAME} - token.set portal.updateSessionToken res`,
                res
            );
        });
  */

  if (startTmr) {
    (0, _timer.clearTimer)();
    (0, _timer.startTimer)(token, decode(token).time_out);
  } else {
    (0, _timer.clearTimer)();
  }

  logger.debug("".concat(MODULE_NAME, " - set res"), true);
  return true;
};

exports.set = set;